<template lang="pug">
div
  BriqTable
    tr
      th Date
      th Amount
      th Method
      th Status
      th Description
      th Processor
    tr.cursor-pointer(v-for="(p, i) in payments" :key="i"  @click="clickPayment(p)")
      td {{ formatDateTime(p.CreateDatetimeUTC) }}
      td {{ formatPrice(p.Amount) }}
      td {{ p.PaymentMethod }}
      td {{ p.Status }} ({{ formatDateTime(p.StatusDatetimeUTC) }})
      td {{ p.Description }}
      td {{ p.Processor }}
  PaymentSlideInPanel(
    :payment="focusedPayment"
    :sidePanelIsOpen="sidePanelIsOpen"
    :amountPaid="amountPaid"
    @refund="x => $emit('refund', x)"
    @close="sidePanelIsOpen = false"
    )
</template>

<script>
import { fromUtc } from '@/helpers/dateTimeFormatter.js'
import { currencyFormatter } from '@/helpers/intlFormatter.js'
import PaymentSlideInPanel from './PaymentSlideInPanel.vue'

export default {
  name: 'PaymentsTable',
  components: { PaymentSlideInPanel },
  props: {
    payments: Array,
    amountPaid: Number,
  },
  data() {
    return {
      focusedPayment: null,
      sidePanelIsOpen: false,
    }
  },
  methods: {
    formatPrice(price) {
      return currencyFormatter(this.$locale, this.$currency).format(price)
    },
    formatDateTime(dateTimeUtc) {
      return fromUtc()(this.$locale)(this.$timezone)(dateTimeUtc)
    },
    clickPayment(payment) {
      this.focusedPayment = payment
      this.sidePanelIsOpen = true
    },
  },
}
</script>

<style scoped lang="stylus"></style>
